"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ERC721SubscriptionModule__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_erc721collection",
                type: "address"
            },
            {
                internalType: "address",
                name: "_sender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_price",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "_period",
                type: "uint256"
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "erc721collection",
        outputs: [
            {
                internalType: "contract IERC721",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "period",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "price",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "sender",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "transferETH",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_receiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            },
        ],
        name: "triggerPayment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var ERC721SubscriptionModule__factory = /** @class */ (function (_super) {
    __extends(ERC721SubscriptionModule__factory, _super);
    function ERC721SubscriptionModule__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    ERC721SubscriptionModule__factory.prototype.deploy = function (_erc721collection, _sender, _price, _period, overrides) {
        return _super.prototype.deploy.call(this, _erc721collection, _sender, _price, _period, overrides || {});
    };
    ERC721SubscriptionModule__factory.prototype.getDeployTransaction = function (_erc721collection, _sender, _price, _period, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _erc721collection, _sender, _price, _period, overrides || {});
    };
    ERC721SubscriptionModule__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ERC721SubscriptionModule__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ERC721SubscriptionModule__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    ERC721SubscriptionModule__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    ERC721SubscriptionModule__factory.bytecode = _bytecode;
    ERC721SubscriptionModule__factory.abi = _abi;
    return ERC721SubscriptionModule__factory;
}(ethers_1.ContractFactory));
exports.ERC721SubscriptionModule__factory = ERC721SubscriptionModule__factory;
